import React from 'react';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import isDesktop from 'store/app/selector/isDesktop';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import OpPlusLogoSmall from 'components/Common/Icons/opplus/OpPlusLogoSmall';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import addOPPlusSubscriptionAndRedirectToCartOperation from 'store/app/operation/addOPPlusSubscriptionAndRedirectToCartOperation';
import getOpPlusV3Info from 'store/dashboard/selector/getOpPlusV3Info';
import styles from './PlusNonMember.module.scss';

const PlusNonMemberBanner = () => {
  const isDesktopDevice = useSelector(isDesktop);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const subscriptionData = useSelector(getOpPlusV3Info);

  const addOPPlus = () => {
    dispatch(addOPPlusSubscriptionAndRedirectToCartOperation());
  };

  return (
    <div className={styles.plusBanner}>
      <div className={styles.bannerContainer}>
        <div className={styles.welcomeMessage}>
          <OpPlusLogoSmall />
        </div>
        {subscriptionData?.nonPlusInfo?.nonMemberPrice && (
          <OpText
            variant={isDesktopDevice ? 'headline-small-bold' : 'title-medium-bold'}
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: `${subscriptionData?.customerInfo.firstName} ${t('txt_plus_non_member_banner_title', {
                opplus_price: subscriptionData?.nonPlusInfo?.nonMemberPrice,
              })}`,
            }}
          />
        )}
        <OpText variant={isDesktopDevice ? 'title-medium-regular' : 'body-large-regular'} className={styles.subtitle}>
          {t('txt_plus_non_member_banner_subtitle')}
        </OpText>
        <OpButton
          onClick={addOPPlus}
          variant="primary"
          size="large"
          color="inverse-teal"
          icon-right="arrow-right"
          className={styles.button}
        >
          <OpText variant="body-large-medium">{t('txt_sign_up_for_plus')}</OpText>
        </OpButton>
      </div>
    </div>
  );
};

export default PlusNonMemberBanner;
